import Chip from '@mui/material/Chip';
import { useI18n } from 'locales';
import PropTypes from 'prop-types';

const statusToColorMap = {
  'Pending': 'yellow',
  'Completed': 'green',
  'Enabled': 'green',
  'Active': 'green',
  'Disabled': 'blueGrey',
  'Cancelled': 'blueGrey',
};

function StatusChip({ status }) {
  const t = useI18n();
  return (
    <Chip
      label={t(status)}
      className='leading-[20px] !py-3'
      sx={statusToColorMap[status] && {
        backgroundColor: `${statusToColorMap[status]}.100`,
        color: `${statusToColorMap[status]}.800`,
      }}
    />
  );
}

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusChip;
